import { Variant } from "./variant";
import { ProductImages } from "./product-images";
import { SellingPlanGroup } from "../cart/selling-plan";
export var productGetUrl = function productGetUrl(_ref) {
  var product = _ref.product;
  return "/products/".concat(product.handle);
};
export var productGetUrlFromHandle = function productGetUrlFromHandle(p) {
  return "/products/".concat(p.handle);
};